import React, { ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  description: string;
  canonical: string;
  keywords?: string;
  ogType?: string;
  ogImage?: string;
  children?: ReactNode;
}

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  canonical,
  keywords = 'página web barata, página web económica, diseño web económico, desarrollo web barato',
  ogType = 'website',
  ogImage = 'https://webabajocoste.es/logo512.png',
  children
}) => {
  const siteTitle = 'Web a Bajo Coste | Páginas Web Baratas Optimizadas para SEO';
  const fullTitle = title === 'Inicio' ? siteTitle : `${title} | Web a Bajo Coste`;
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonical} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {children}
    </Helmet>
  );
};

export default SEO; 